define('RunOnEveryPage/components/formSpinner',[],

    function () {

        function init() {
            // adding the click handler on document level, so it doesn't disappear when form is reloaded dynamically.
            $(document).on('click', 'form input[type="submit"]', function (event) {               
            //Added additional check if validation is valid, then show spinner              
                var validate = $(this).closest("form").validate(); // Get validate instance
                var isValid = validate.checkForm(); // Valid?
                validate.submitted = {}; // Reset immediate form field checking mode
                if (isValid)
                    // This will show the spinner overlay when submit button is clicked, and the overlay will go to its
                    // default state (hidden) when the form is reloaded (or completely removed) after submit process is done.
                    $(this).closest("form").find(".spinner-overlay").removeClass("d-none");
            });
        }

        return {
            init: init
        };

    }

);
